













































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';


@Component({
	name: 'progress-bar',

})
export default class ProgressBar extends Vue {
	@Prop({required: true }) applicationStep!: number;
}
